import { fetchConditionalPropertyOptionRules } from './api';
export class ConditionalPropertyOptionsRulesCache {
  constructor() {
    this.cache = {};
  }

  get({
    objectTypeId,
    httpClient
  }) {
    if (Object.prototype.hasOwnProperty.call(this.cache, objectTypeId)) {
      return this.cache[objectTypeId];
    }

    const promise = fetchConditionalPropertyOptionRules(objectTypeId, httpClient) // CPO is a best-effort implementation.
    // So, if we are not able to fetch CPO rules, we will skip filtering (as if there are no rules) instead of erroring out
    .catch(__err => {
      return [];
    });
    this.cache[objectTypeId] = promise;
    return promise;
  }

  clear() {
    this.cache = {};
  }

}